import { formatCycleIdentifier } from "./dashboard-cycle-utils";

export const getCycleValue = cycle => {
	return (
		cycle?.ciclo ||
		cycle?.id ||
		cycle?.idCiclo ||
		cycle?.codigo ||
		cycle?.rotulo ||
		cycle?.label ||
		""
	);
};

const normalizeCyclesData = cyclesData => {
	if (Array.isArray(cyclesData?.resultado)) {
		return cyclesData.resultado;
	}

	if (Array.isArray(cyclesData)) {
		return cyclesData;
	}

	return [];
};

export const formatContractCycle = cycle => {
	const rawCycleValue = getCycleValue(cycle);
	const formattedCycle = formatCycleIdentifier(rawCycleValue);

	const cycleYear = cycle?.ano || formattedCycle.year;
	const cycleLabel = formattedCycle.apiValue;

	const selectValue = cycleYear
		? `${cycleYear}-${cycleLabel}`
		: String(cycleLabel);

	const isOpen = Boolean(cycle?.aberto);
	const isClosed = !isOpen;

	return {
		...cycle,
		value: selectValue,
		apiValue: String(cycleLabel),
		label: cycleYear
			? `${cycleYear} - ${cycleLabel}`
			: String(cycleLabel),
		cycle: cycleLabel,
		year: cycleYear,
		order: cycle?.ordem,
		isOpen,
		isClosed,
		status: isOpen ? "ABERTO" : "FECHADO",
		raw: cycle
	};
};

export const formatContractCyclesResponse = cyclesData => {
	return normalizeCyclesData(cyclesData)
		.map(formatContractCycle)
		.sort((firstCycle, secondCycle) => {
			return Number(firstCycle.order || 0) - Number(secondCycle.order || 0);
		});
};